export const ACCOUNT_LANGUAGES = [
  { key: 'de', label: 'DE', name: 'German', nativeName: 'Deutsch' },
  { key: 'en', label: 'EN', name: 'English', nativeName: 'English' },
  { key: 'it', label: 'IT', name: 'Italian', nativeName: 'Italiano' },
  { key: 'fr', label: 'FR', name: 'French', nativeName: 'Français' },
  { key: 'es', label: 'ES', name: 'Spanish', nativeName: 'Español' },
  { key: 'pt', label: 'PT', name: 'Portuguese', nativeName: 'Português' },
  { key: 'nl', label: 'NL', name: 'Dutch', nativeName: 'Nederlands' },
  { key: 'sq', label: 'SQ', name: 'Albanian', nativeName: 'Shqip' },
  { key: 'tr', label: 'TR', name: 'Turkish', nativeName: 'Türkçe' },
  { key: 'ar', label: 'AR', name: 'Arabic', nativeName: 'العربية' },
  { key: 'sr', label: 'SR', name: 'Serbian', nativeName: 'Srpski' },
  { key: 'hr', label: 'HR', name: 'Croatian', nativeName: 'Hrvatski' },
  { key: 'pl', label: 'PL', name: 'Polish', nativeName: 'Polski' },
];

export const getAccountLanguage = (user) => (
  ACCOUNT_LANGUAGES.some((option) => option.key === user?.preferred_language)
    ? user.preferred_language
    : 'de'
);

let communicationAccountLanguage = 'de';

export const setCommunicationAccountLanguage = (user) => {
  communicationAccountLanguage = getAccountLanguage(user);
};

export const withAccountLanguage = (payload) => ({
  source_language: communicationAccountLanguage,
  ...payload,
});
